import { ColumnsType } from 'antd/lib/table'
import { FilterOptions } from '../../../../CIMSColumn/types/filter'
import {
  LoadingOutlined,
  SearchOutlined,
  CheckSquareFilled,
  CalendarFilled,
  CalculatorFilled,
  FilterFilled,
} from '@ant-design/icons'
import { useCallback } from 'react'

export function useGetFilterIcon<T>() {
  return useCallback<
    (filter: FilterOptions<T>) => ColumnsType<T>[number]['filterIcon']
  >(({ type, loading }) => {
    // the animation for this is messed up, but i'm leaving this here in the
    // event it isn't messed up in future versions of Ant D
    if (loading) return <LoadingOutlined />
    else if (type === 'search')
      return (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      )
    else if (type === 'boolean' || type === 'checkboxes')
      return <CheckSquareFilled />
    else if (type === 'date') return <CalendarFilled />
    else if (type === 'number') return <CalculatorFilled />
    else return <FilterFilled />
  }, [])
}
